/**
 * Adapter Layer - Makes API requests for authentication operations
 */

import { apiClient } from '../config/api-client'

export type UpdatePasswordPayload = {
  currentPassword: string
  newPassword: string
}

export async function changePasswordApi(
  userId: string,
  payload: UpdatePasswordPayload,
): Promise<void> {
  return apiClient.put<void>(`/auth/${userId}/change-password`, payload)
}

export type SyncGooglePicturePayload = {
  pictureUrl: string
}

export async function syncGooglePictureApi(
  payload: SyncGooglePicturePayload,
): Promise<{ success: boolean }> {
  return apiClient.post<{ success: boolean }>(
    '/auth/sync-google-picture',
    payload,
  )
}
